// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import {
  getTotalSpend,
  getCurrentPerkLevel,
  getNextPerkLevel,
  getSpendLeftForNextPerk,
} from '@tcp/core/src/components/features/account/User/container/User.selectors';
import {
  getPlacePerksDisplayThreshold,
  getRockStarPerks,
  getSuperStarPerks,
  getMegaStarPerks,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { getSubTotal } from '../../common/organism/OrderLedger/container/orderLedger.selector';
import PlacePerkBannerView from '../views/PlacePerkBanner.view';

const PlacePerkBannerContainer = ({
  nextPerkLevel,
  spendLeftForNextPerk,
  cartTotal,
  pageVariant,
  orderTotal,
  displayThreshold,
  rockStarPerks,
  superStarPerks,
  megaStarPerks,
  currentPerkLevel,
}) => {
  const rockStarPerksData = isEmpty(rockStarPerks) ? [] : rockStarPerks;
  const superStarPerksData = isEmpty(superStarPerks) ? [] : superStarPerks;
  const megaStarPerksData = isEmpty(megaStarPerks) ? [] : megaStarPerks;

  const perksRewardsContent = {
    rockstar: rockStarPerksData,
    superstar: superStarPerksData,
    megastar: megaStarPerksData,
  };

  const offerList = perksRewardsContent[nextPerkLevel?.toLowerCase()];

  return (
    <PlacePerkBannerView
      perkLevel={nextPerkLevel}
      currentPerkLevel={currentPerkLevel}
      spendLeftForNextPerk={spendLeftForNextPerk}
      cartTotal={cartTotal} // value sent from container itself not from parent component
      pageVariant={pageVariant}
      orderTotal={orderTotal}
      displayThreshold={displayThreshold}
      offerList={offerList}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    totalSpend: getTotalSpend(state),
    currentPerkLevel: getCurrentPerkLevel(state),
    nextPerkLevel: getNextPerkLevel(state),
    spendLeftForNextPerk: getSpendLeftForNextPerk(state),
    cartTotal: getSubTotal(state),
    displayThreshold: getPlacePerksDisplayThreshold(state),
    rockStarPerks: getRockStarPerks(state),
    superStarPerks: getSuperStarPerks(state),
    megaStarPerks: getMegaStarPerks(state),
  };
};

PlacePerkBannerContainer.propTypes = {
  currentPerkLevel: PropTypes.string,
  nextPerkLevel: PropTypes.string,
  spendLeftForNextPerk: PropTypes.number,
  pageVariant: PropTypes.string,
  cartTotal: PropTypes.number,
  orderTotal: PropTypes.number,
  displayThreshold: PropTypes.number,
  rockStarPerks: PropTypes.shape([]).isRequired,
  superStarPerks: PropTypes.shape([]).isRequired,
  megaStarPerks: PropTypes.shape([]).isRequired,
};

PlacePerkBannerContainer.defaultProps = {
  currentPerkLevel: 'ROCKSTAR',
  nextPerkLevel: 'SUPERSTAR',
  spendLeftForNextPerk: 0,
  pageVariant: '',
  cartTotal: 0,
  orderTotal: 0,
  displayThreshold: 25,
};

export default connect(mapStateToProps)(PlacePerkBannerContainer);
export { PlacePerkBannerContainer as PlacePerksContainerVanilla };
